export const tabEnums = {
    DRAW: 'Draw',
    TYPE: 'Type',
    UPLOAD: 'Upload',
};

export const signatureTabsLabels = [
    {
        label: 'Draw',
    },
    {
        label: 'Type',
    },
    {
        label: 'Upload',
    },
];
